import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { map } from 'rxjs/operators';

import { SecurityService } from '@bayclubs/utils';

import { GcNavigationService } from './gc-navigation.service';

@Injectable({
    providedIn: 'root'
})
export class GcPermissionGuard  {
    constructor(private navigation: GcNavigationService, private security: SecurityService) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const expectedPermission = this.security.splitPrivilegePath(route.data.expectedPermission);
        return this.security.hasPrivilege(expectedPermission.scope, expectedPermission.privilege).pipe(
            map(result => {
                if (!result) {
                    this.navigation.goTo403();
                }
                return result;
            })
        );
    }
}
